import React from 'react'

const HighSpeedIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C10.2895 8.125 10.5636 8.19059 10.8084 8.30773L13.933 5.18307L14.8169 6.06695L11.6923 9.19161C11.8094 9.43639 11.875 9.71053 11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10ZM10 9.375C9.65482 9.375 9.375 9.65482 9.375 10C9.375 10.3452 9.65482 10.625 10 10.625C10.3452 10.625 10.625 10.3452 10.625 10C10.625 9.65482 10.3452 9.375 10 9.375Z'
        fill='#141414'
      />
      <path d='M9.375 5.625V3.75H10.625V5.625H9.375Z' fill='#141414' />
      <path d='M16.25 9.375H14.375V10.625H16.25V9.375Z' fill='#141414' />
      <path d='M3.75 9.375H5.625V10.625H3.75V9.375Z' fill='#141414' />
      <path d='M6.90641 6.2814L5.58059 4.95557L4.6967 5.83945L6.02253 7.16528L6.90641 6.2814Z' fill='#141414' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25ZM2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 12.0984 16.6383 13.9955 15.2493 15.3567C14.1362 13.6382 12.2015 12.5 9.99998 12.5C7.79844 12.5 5.86377 13.6382 4.75064 15.3567C3.36174 13.9955 2.5 12.0984 2.5 10ZM5.72159 16.1608C6.93503 17.005 8.40971 17.5 10 17.5C11.5903 17.5 13.065 17.0051 14.2784 16.1608C13.4014 14.7149 11.8128 13.75 9.99998 13.75C8.18714 13.75 6.59854 14.7149 5.72159 16.1608Z'
        fill='#141414'
      />
    </svg>
  )
}

export default HighSpeedIcon
